// REACT & REDUX
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Field, Form, reduxForm, submit } from 'redux-form';
import { ToastContainer, toast } from 'react-toastify';
import * as http from '../../api/base.api';
import { withStyles } from '@material-ui/core/styles';
import moment from "moment";

// STYLE, PROPS & TRANSLATIONS

// COMMON
import { required, maxLength } from "../../common/validators";
import { CERTIFICATE_SUBMIT_FORM } from "../../actions/actionTypes";

// COMPONENTS
import { Brand, Table, CardBody, Button, FlexContainer, FlexItem, Spinner, TextInput, InputContainer, OverlayTrigger, Tooltip } from 'careconnect-ui';
import ReduxFieldText from "../common/ReduxFieldText";
import { convertDataToFormDataFormat } from "../../common/helpers.js";
import { CopyToClipboard } from 'react-copy-to-clipboard';

// CONTAINERS

// ACTIONS & API
import { dropFileCompleted, uploadCertificate, clientSecretsInitialize, selectedRiziv } from '../../actions/certificate.actions';

// *************************************************************************************************************************************

const styles = theme => ({
    menuStyle: {
        fontSize: '100%'
    },
    selectEmpty: {
        display: 'block',
        flexWrap: 'wrap',
        fontSize: '100%',
        marginTop: theme.spacing.unit * 2
    }
});

const requiredVal = required();
const max50 = maxLength(50);

class Upload extends Component {
    constructor() {
        super();
        this.state = {
            files: [],
            hcoNumber: "",
            keyStore: "",
            KeyStoreVerification: "",
            clientid: "",
            secretid: "",
            isAuthenticated: false,
            clientSecrets: [],
            loading: true,
            selectedIndex: 0,
            applicationId: "",
            savedSucceed: false
        };
    }

    onDrop(files) {
        if (!files[0].name.endsWith(".pfx") && !files[0].name.endsWith("p12")) {
            toast.error("Het bestandsformaat moet pfx of p12 zijn",
                {
                    position: toast.POSITION.TOP_CENTER
                });
            return;
        }

        this.setState({ files: files });
        this.props.dispatch(dropFileCompleted(files));
    }

    async componentWillMount() {
        const usersInfo = await http.get(`api/certificates/`).then(async (response) => {
            return response.data;//response.data;
        }, (error) => {
            return "";
        });

        this.state.files = [];
        if (usersInfo.isAuthenticated) {
            if (usersInfo.clientSecrets instanceof Array && usersInfo.clientSecrets.length > 0) {
                this.setState({
                    loading: false,
                    isAuthenticated: true,
                    clientid: "",//usersInfo.clientSecrets[0].clientId"",
                    secretid: "",//usersInfo.clientSecrets[0].secretId,
                    clientSecrets: usersInfo.clientSecrets,
                    applicationId: "",
                    savedSucceed: false
                });
                this.props.dispatch(clientSecretsInitialize(usersInfo.clientSecrets));
            } else {
                this.setState({
                    loading: false,
                    isAuthenticated: true,
                    clientid: "",
                    secretid: "",
                    clientSecrets: [],
                    applicationId: "",
                    savedSucceed: false
                });
            }
        } else {
            this.setState({ isAuthenticated: false, clientid: undefined, secretid: undefined, loading: false });
        }
    }

    onSubmit(values) {
        //e.preventDefault();

        var formData = convertDataToFormDataFormat(values);
        //   if (this.props.files !== null && this.props.uploadFiles.uploadFiles !== undefined && this.props.uploadFiles.uploadFiles.length > 0) {
        if ((this.state.savedSucceed && this.state.savedSucceed == true) || (this.state.files !== null && this.state.files !== undefined && this.state.files.length > 0)) {
            if (values.KeyStore === undefined || values.KeyStore === "") {
                toast.error("Je moet een Wachtwoorden invullen",
                    {
                        position: toast.POSITION.TOP_CENTER
                    });
            } else if (values.KeyStore !== "" && values.KeyStore !== undefined && values.KeyStoreVerification !== values.KeyStore) {
                toast.error("Wachtwoorden zijn anders",
                    {
                        position: toast.POSITION.TOP_CENTER
                    });
            } else if (values.Riziv === "") {
                toast.error("Je moet een Riziv kiezen",
                    {
                        position: toast.POSITION.TOP_CENTER
                    });
            } else {
                let clientSecrets = this.state.clientSecrets;
                clientSecrets[this.state.selectedIndex - 1].hasCertificate = true;
                this.setState({ clientSecrets: clientSecrets });
                this.props.upload(this.state.files, formData);
            }
        } else {
            toast.error("Voeg een certificaat toe",
                {
                    position: toast.POSITION.TOP_CENTER
                });
        }
    }

    createTable = (clientSecrets) => {
        let table = []

        // Outer loop to create parent
        for (let i = 0; i < clientSecrets.length; i++) {
            let children = []
            //Inner loop to create children

            children.push(<td style={{ marginRight: '50em' }} >{clientSecrets[i].hcoNumber}</td>)
            if (clientSecrets[i].hasCertificate) {
                children.push(<td style={{ textAlign: "center" }} ><i className="if if-checkmark" /></td>)
            } else {
                children.push(<td style={{ textAlign: "center" }} ></td>)
            }

            children.push(<td style={{ marginRight: '70em' }} >{moment(clientSecrets[i].endDate).format("DD-MM-YYYY")}</td>)

            //Create the parent and add the children
            table.push(<tr>{children}</tr>)
        }
        return table
    };

    handleChange = (event, items) => {
        this.setState({ hcoNumber: event.target.value });

        let clientid = "";
        let secretid = "";

        let selectedIndex = event.target.options.selectedIndex;

        console.warn(items);
        console.warn(selectedIndex);

        if (selectedIndex > 0 && items[selectedIndex - 1]) {
            clientid = items[selectedIndex - 1].clientId;
            secretid = items[selectedIndex - 1].secretId;
            //clientid = items[selectedIndex].clientId;
            //secretid = items[selectedIndex].secretId;
        }

        console.warn(selectedIndex);

        this.setState({ selectedIndex: selectedIndex });
        this.setState({ clientid: clientid });
        this.setState({ secretid: secretid });

        this.props.dispatch(selectedRiziv(selectedIndex));
    };

    handleClick = (e) => {
        console.log("remove");

        this.setState({ files: [] });
    }

    render() {
        var labelStyle = {
            color: '#323335',
            fontWeight: '500',
            padding: '0.8rem 0'
        };

        const { handleSubmit, classes, disableUploadButton } = this.props;
        const { clientid, secretid, isAuthenticated, clientSecrets, loading, applicationId } = this.state;
        if (loading) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <Spinner size="large" />
                </div>
            )
        }
        else if (!isAuthenticated) {
            return (
                <p>You are not authorized to access this page</p>
            );
        }
        else {
            return (
                <FlexContainer vertical center>
                    <ToastContainer />
                    <br />
                    <Brand logo="./images/mark.svg" brandName="CareConnect" productName="EWZCFin" size="large" />
                    <br />
                    <FlexContainer horizontal >
                        <CardBody>
                            <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} >
                                <div class="c-input">

                                    <label class="c-input__label" style={labelStyle}>Riziv nummer *</label>

                                    <div style={{ padding: + "8 8 8 8" }}>
                                        <Field
                                            label="Riziv nummer"
                                            value={this.state.hcoNumber}
                                            onChange={(event) => this.handleChange(event, clientSecrets)}
                                            name="Riziv"
                                            required
                                            component="select"
                                            hintText="Kies een Riziv nummer"
                                        >

                                            <option style={{ padding: + "8 8 8 8" }} value="" disabled>Kies een riziv nummer</option>

                                            {clientSecrets.map((item, i) => <option key={item.hcoNumber} value={item.hcoNumber} >{item.hcoNumber}</option>)}

                                        </Field>
                                    </div>
                                </div>

                                <Field
                                    label="Voer het wachtwoord van uw certificaat in"
                                    name="KeyStore"
                                    placeholder="Wachtwoord"
                                    validate={[requiredVal, max50]}
                                    component={ReduxFieldText}
                                    required
                                    type="password"
                                    value={this.state.keyStore}
                                />

                                <Field
                                    label="Herhaal wachtwoord"
                                    name="KeyStoreVerification"
                                    placeholder="Herhaal wachtwoord"
                                    validate={[requiredVal, max50]}
                                    component={ReduxFieldText}
                                    required
                                    type="password"
                                    value={this.state.keyStoreVerification}
                                />

                                <Field
                                    label="Toepassings-ID"
                                    name="ApplicationId"
                                    placeholder="Toepassings-ID"
                                    validate={[requiredVal, max50]}
                                    component={ReduxFieldText}
                                    value={this.state.applicationId}
                                />

                                <br />
                                <section>
                                    <div className="dropzone">
                                        <Dropzone onDrop={this.onDrop.bind(this)}>
                                            <p> Sleep uw certificaat naar dit veld of klik hier om een bestand te selecteren</p>
                                        </Dropzone>
                                    </div>

                                    <aside>
                                        <h2>Certificaat:</h2>

                                        {
                                            this.state.files.map(f => {
                                                return (
                                                    <label style={{ textOverflow: +"ellipsis", overflow: +"hidden" }} key={f.name}>{f.name}
                                                        <Button onClick={this.handleClick} styleType="borderless" iconType="duplicate" />
                                                    </label>);
                                            })}

                                    </aside>
                                </section>
                                <br />
                                <Button
                                    disabled={disableUploadButton}
                                    styleType="primary" type="submit" text='Bewaar' />

                                <p>&nbsp;</p>

                            </Form>
                        </CardBody>
                        <FlexItem>

                            <CardBody>
                                <FlexContainer>
                                    <FlexItem>
                                        <InputContainer label="Client ID">
                                            <FlexContainer>
                                                <TextInput disabled type="text" value={clientid} />
                                                <FlexItem>
                                                    <CopyToClipboard text={clientid} >
                                                        <Button styleType="borderless" iconType="duplicate" />
                                                    </CopyToClipboard>
                                                </FlexItem>
                                            </FlexContainer>
                                        </InputContainer>
                                    </FlexItem>
                                </FlexContainer>
                                <FlexContainer>
                                    <FlexItem>
                                        <InputContainer label="Secret ID">
                                            <FlexContainer>
                                                <TextInput disabled type="text" value={secretid} />
                                                <FlexItem>
                                                    <CopyToClipboard text={secretid} >
                                                        <Button styleType="borderless" iconType="duplicate" />
                                                    </CopyToClipboard>
                                                </FlexItem>
                                            </FlexContainer>
                                        </InputContainer>
                                    </FlexItem>
                                </FlexContainer>
                            </CardBody>

                            <CardBody>
                                <Table alignMiddle="true">
                                    <th><p>Riziv</p></th><th><p>Cerficaat</p></th><th><p>Einddatum</p></th>
                                    {this.createTable(clientSecrets)}
                                </Table>
                            </CardBody>
                        </FlexItem>

                    </FlexContainer>

                </FlexContainer>
            );
        }
    }
}
const form = reduxForm({ form: CERTIFICATE_SUBMIT_FORM });

export default form(Upload);